<div class="individual-form-dialog container-fluid">
  <form [formGroup]="formGroup">
    <div class="row pt-4">
      <div class="col">
        <h3 class="subheading-2">{{ heading() }}</h3>
      </div>
    </div>

    @if (data.existingPersonOptions?.length) {
      <div class="row pb-3">
        <div class="col">
          <mat-button-toggle-group
            aria-label="Choose how to add the KYB person"
            [hideSingleSelectionIndicator]="true"
            [value]="formControlResolutionMode.value"
            (change)="setResolutionMode($event.value)">
            <mat-button-toggle value="EXISTING">Use existing person</mat-button-toggle>
            <mat-button-toggle value="NEW">Add new person</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>
      @if (isLinkingExisting()) {
        <div class="row">
          <div class="col-12">
            <mat-form-field>
              <mat-label>Existing application person</mat-label>
              <mat-select [formControl]="formControlExistingPersonIndividualId">
                @for (option of data.existingPersonOptions ?? []; track option.individualId) {
                  <mat-option [value]="option.individualId">
                    {{ option.name }}
                    @if (option.dateOfBirth) {
                      — DOB {{ option.dateOfBirth }}
                    }
                    @if (option.suggested) {
                      (suggested match)
                    }
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }
    }

    <div class="row">
      <div class="col-4">
        <mat-form-field>
          <mat-label>Role</mat-label>
          <mat-select [formControl]="formControlSignerRole">
            <mat-option [value]="'Signer'">Signer</mat-option>
            <mat-option [value]="'Guarantor'">Guarantor</mat-option>
            <mat-option [value]="'GuarantorSigner'">Guarantor / Signer</mat-option>
            @if (data.allowTrusteePartnerRoles) {
            <mat-option [value]="'Trustee'">Trustee</mat-option>
            <mat-option [value]="'Partner'">Partner</mat-option>
            }
            <mat-option [value]="'Others'">Others</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if (needsOwner() && !data.lockRole) {
    <div class="row">
      <div class="col-6">
        <mat-form-field>
          <mat-label>{{ formControlSignerRole.value === 'Trustee' ? 'Trustee of' : 'Partner of' }}</mat-label>
          <mat-select [formControl]="formControlOwner">
            @for (owner of data.ownerEntities ?? []; track owner.commercialEntityId) {
            <mat-option [value]="owner.commercialEntityId">{{ owner.entityName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    }
    @if (needsOwner() && data.lockRole && data.ownerEntities?.length === 1) {
    <div class="row">
      <div class="col-6">
        <p><strong>{{ formControlSignerRole.value === 'Trustee' ? 'Trustee of' : 'Partner of' }}:</strong> {{ data.ownerEntities![0].entityName }}</p>
      </div>
    </div>
    }

    @if (!isLinkingExisting()) {
      <!-- An existing individual's ID document is already held against the application, so requiring
           a fresh upload would block an edit made to correct something else. -->
      <individual-form
        [showPropertyOwner]="false"
        [showIdDocumentUpload]="showIdDocumentUpload()"
        [idDocumentProvided]="!!data.idDocumentProvided"
        [existingIdDocuments]="data.existingIdDocuments ?? []"
        [showResidencyProofAlert]="residencyAlertApplies()"
        [formControl]="formControlIndividual">
      </individual-form>
    }

    @if (!isLinkingExisting() && isDuplicateEmail()) {
      <div class="row">
        <div class="col">
          <mat-error>This email address is already used by another individual on this application.</mat-error>
        </div>
      </div>
    }
    @if (!isLinkingExisting() && isDuplicateMobile()) {
      <div class="row">
        <div class="col">
          <mat-error>This mobile number is already used by another individual on this application.</mat-error>
        </div>
      </div>
    }
    @if (duplicateIdentityError()) {
      <div class="row">
        <div class="col">
          <mat-error>{{duplicateIdentityError()}}</mat-error>
        </div>
      </div>
    }
    @if (duplicateIdentityWarning()) {
      <div class="row">
        <div class="col">
          <div class="duplicate-warning">{{duplicateIdentityWarning()}}</div>
        </div>
      </div>
    }

    <div class="row pb-4">
      <div class="col">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <button mat-stroked-button (click)="onCancel()">Cancel</button>
          <button mat-flat-button [disabled]="disableSubmission()" (click)="onSubmit()">
            {{ submitLabel() }}
          </button>
        </div>
      </div>
    </div>

  </form>
</div>
